import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Notification } from '@paragon/notification-tools';

type DelayedNotificationsState = Record<string, Notification[]>;
const initialState: DelayedNotificationsState = {};

const delayedNotificationsSlice = createSlice({
  name: 'delayedNotifications',
  initialState,
  reducers: {
    enqueueDelayedNotification: (
      state,
      action: PayloadAction<{ notification: Notification; componentDesignGuid: string }>,
    ) => {
      state[action.payload.componentDesignGuid] = (state[action.payload.componentDesignGuid] ?? []).concat([
        action.payload.notification,
      ]);
    },
    clearDelayedNotifications: (state, action: PayloadAction<{ componentDesignGuid: string }>) => {
      delete state[action.payload.componentDesignGuid];
    },
  },
});

export const { enqueueDelayedNotification, clearDelayedNotifications } = delayedNotificationsSlice.actions;
export const delayedNotifications = delayedNotificationsSlice.reducer;
